import Storage from './Storage'

export default function installFrigidaire(ctx, inject) {
  const paths = ['country','tradeType','dateRange','selectedDatePreset','isIncompleteDataShown','analytics.isResultsClean','analytics.chartType','analytics.measurement','analytics.field','company.stat','company.dateRange','company.selectedDatePreset','company.sortField','company.sortOrder','company.pageLimit','company.shipments.sortField','company.shipments.sortOrder','company.shipments.pageLimit','dataViewer.viewType','downloads.dateRange','views.activeShipmentsView.name','search.pageLimit','search.sortField','search.sortOrder','search.stat','search.bookmarkDateRange']
  const storage = new Storage({ paths, store: ctx.store })
  ctx.$storage = storage
  inject('storage', storage)
}
